

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CRETEKRAKPIQUESTIONFORKRAKPI= createAsyncThunk(
  "createKraKpiQuestionForkrakpi/createKraKpiQuestionForkrakpi",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createKraKpiQuestionForkrakpiSlice = createSlice({
  name: "createKraKpiQuestionForkrakpiSlice",
  initialState: {
    createKraKpiQuestionForkrakpi: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateKraKpiQuestionForkrakpi: (state) => {
        state.createKraKpiQuestionForkrakpi.loading = false
        state.createKraKpiQuestionForkrakpi.error = false
        state.createKraKpiQuestionForkrakpi.data = []
        state.createKraKpiQuestionForkrakpi.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CRETEKRAKPIQUESTIONFORKRAKPI.fulfilled, (state, action) => {
      state.createKraKpiQuestionForkrakpi = {
        ...state.createKraKpiQuestionForkrakpi,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CRETEKRAKPIQUESTIONFORKRAKPI.pending, (state, action) => {
      state.createKraKpiQuestionForkrakpi = {
        ...state.createKraKpiQuestionForkrakpi,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CRETEKRAKPIQUESTIONFORKRAKPI.rejected, (state, action) => {
      state.createKraKpiQuestionForkrakpi = {
        ...state.createKraKpiQuestionForkrakpi,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createKraKpiQuestionForkrakpiAction = {
    CRETEKRAKPIQUESTIONFORKRAKPI,
};

export { createKraKpiQuestionForkrakpiAction };
export default createKraKpiQuestionForkrakpiSlice.reducer;
export const {setInitialStateOfcreateKraKpiQuestionForkrakpi} = createKraKpiQuestionForkrakpiSlice.actions
